export const GET_Health_LOADING = "Health/get/laoding";
export const GET_Health_SUCCESS = "Health/get/success";
export const GET_Health_ERROR = "Health/get/error";

// add item  
export const ADD_Health_LOADING = "Health/add/laoding";
export const ADD_Health_SUCCESS = "Health/add/success";
export const ADD_Health_ERROR = "Health/add/error";

// update  
export const UPDATE_Health_LOADING = "Health/update/laoding";
export const UPDATE_Health_SUCCESS = "Health/update/success";
export const UPDATE_Health_ERROR = "Health/update/error";

// REMOVE  
export const REMOVE_Health_LOADING = "Health/remove/laoding";
export const REMOVE_Health_SUCCESS = "Health/remove/success";
export const REMOVE_Health_ERROR = "Health/remove/error";
export const SORT_HEALTH="Health/sort"